<template>
  <div class="TitleFormatAlBronzoCmp">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleFormatAlBronzoCmp',
};
</script>

<style lang="scss" scoped>
.TitleFormatAlBronzoCmp {
  ::v-deep .title-wrapper {
    @include override-responsive-typography-properties(
      $font-secondary,
      n-heading-3,
      --title-text-title-wrapper
    );
    --title-text-title-wrapper-color: #{$color-bronze};

    @include media-breakpoint-up(md) {
      @include override-responsive-typography-properties(
        $font-secondary,
        n-heading-2,
        --title-text-title-wrapper
      );
    }
  }
}
</style>
